import { apiProxyRequest } from "Api/apiProxyRequest";

import type { ProfileAlert } from "../types";

export const deleteProfileAlert = (billingProfileId: string) => {
  return apiProxyRequest<ProfileAlert>(
    `/billing/profiles/${billingProfileId}/alerts/billing`,
    "PATCH",
    {
      active: false,
      config: {}
    }
  );
};
